import React from 'react';
import { ButtonProps } from 'antd/lib/button';
import CcCluster from '../../../services/models/CcCluster';
import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import ClusterRollingRestartForm from './ClusterRollingRestartForm';
import ButtonWithForm from '../../../common/General/ButtonWithForm';
import JobActionButton from '../../Jobs/JobActionButton';

export default ClusterRollingRestartButton;

export type ClusterRollingRestartButtonProps = ButtonProps & {
    cluster: CcCluster;
    children?: React.ReactNode;
    onSuccess?: () => void;
};

function ClusterRollingRestartButton({
    cluster,
    children,
    onSuccess,
    ...rest
}: ClusterRollingRestartButtonProps) {
    return (
        <ButtonWithForm
            button={
                <JobActionButton
                    command={CmonJobInstanceCommand.ROLLING_RESTART}
                    clusterId={cluster.clusterId}
                    critical={true}
                    {...rest}
                >
                    {children || 'Rolling restart'}
                </JobActionButton>
            }
            form={
                <ClusterRollingRestartForm
                    cluster={cluster}
                    onSuccess={onSuccess}
                />
            }
        />
    );
}
